<template>
  
  <div class="col-md-6 container" align="center">
    <form>
    <card no-footer-line>
      <div slot="header">
        <h4 class="card-title">
          Dados Cadastrais
        </h4>
      </div>
      <div>
        <fg-input type="email"
                  required
                  name="email"
                  label="E-mail"
                  v-validate="modelValidations.email"
                  :error="getError('email')"
                  v-model="model.email">
        </fg-input>

        <fg-input label="Senha"
                  required
                  type="password"
                  name="senha"
                  v-validate="modelValidations.senha"
                  :error="getError('senha')"
                  v-model="model.senha">
        </fg-input>

        <fg-input label="Confirmar Senha"
                  required
                  type="password"
                  name="confirmar"
                  v-validate="modelValidations.confirmar"
                  :error="getError('confirmar')"
                  v-model="model.confirmar">
        </fg-input>
        <div class="category form-category">* Campos Obrigatórios</div>

      </div>
      <div slot="footer" class="text-right">
        <n-button native-type="submit" @click.native.prevent="validate" class="btn btn-round btn-wd" type="info">Register</n-button>
      </div>

    </card>
  </form>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
    AnimatedNumber,
  } from 'src/components'
import { setInterval } from 'timers';
import moment from 'moment'
export default {
    components: {
      Card,
      AnimatedNumber,
      moment
    },
    data() {
      return {
        model: {
          email: '',
          senha: '',
          confirmar: ''
        },
        modelValidations: {
          email: {
            required: true,
            email: true
          },
          senha: {
            required: true,
            min: 5
          },
          confirmar: {
            required: true,
            confirmed: 'senha'
          }
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid)
        })
      }
    }
}
</script>